<template>
  <div id="consulta">

    <b-modal
      size="xl"
      scrollable
      title="Resultado"
      id="modal-edital-eletronico"
    >

    <div  v-for="item in items" v-bind:key="item.cd_cartorio">
      <div class="card" style="padding: 10px;margin-bottom: 10px;">
        <div class="card" style="margin-bottom: 10px;background: #e1e1e1;">
          <div class="card-body">
              <p class="text-left" style="color: black;"><b>Documento:{{item.doc_devedor | documento}}</b></p>
              <p class="text-left" style="color: black;"><b>Devedor:</b>{{ item.nomeDevedor | uppert }}</p>
              <p class="text-left" style="color: black;margin: 0;"><b>Cartório/Comarca:</b>{{ item.nome_cartorio | uppert }}/{{ item.uf }}</p>
              <p class="text-left" style="color: black;margin: 0;">{{ item.endereco }} - {{ item.endereco_numero }} - {{ item.bairroc }} - {{ item.cidadec }} / {{ item.uf }} - {{ item.telefone | fone }} </p>
              <p class="text-left" style="color: black;margin: 0;"> {{ item.email }} - {{ item.hora_funcionamento }}</p>
          </div>
        </div>

        <div class="card-body" style="background: #0082C6;">
          <h3 class="text-center" style="color: #fff;">EDITAL ELETRÔNICO NA FORMA DO ART. 3º DO PROVIMENTO 87:</h3>
          <h5 class="text-center" style="color: #fff;"><u>DATA DA PUBLICAÇÃO: {{ item.dt_hr_cadastro | dataBr }}</u></h5>
          <p v-if="item.texto_edital" class="text-center" style="color: #fff;">{{ item.texto_edital }}</p>
          <p v-else class="text-center" style="color: #fff;">A este Tabelionato de Protesto foi solicitada a intimação de V.Sª, para pagamento do título/documento de dívida abaixo indicado. Caso não seja
          efetuado o pagamento nesta serventia até a data limite aqui indicada, será lavrado nos termos da Lei, o respectivo Termo de Protesto.</p>
          <table  stacked class="table table-hover">
          <thead>
            <tr>
              <th style="color: #fff;" class="col-xs-4 col-sm-4 col-md-4 col-lg-4 text-center" scope="cols-4">Endereço</th>
              <th  class="col-xs-3 col-sm-2 col-md-2 col-lg-2 text-center" scope="cols-1" style="text-align: right;color: #fff;">Data de Apresentação</th>
              <!-- th  class="col-xs-1 col-sm-2 col-md-2 col-lg-2 text-center" scope="cols-2" style="text-align: right;color: #fff;">Espécie do Título</th -->
              <!-- th  class="col-xs-1 col-sm-2 col-md-2 col-lg-2 text-center" scope="cols-2" style="text-align: right;color: #fff;">*Prazo para Pagamento </th -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="it in item.editalf[0]"  v-bind:key="it.doc_devedor">
              <td style="color: #fff;" class="text-center">{{ it.bairroDevedor }}  - {{ it.cidadeDevedor}}</td>
              <td style="color: #fff;" class="text-center">{{ it.dataApresentacao | data}}</td>
              <!-- td style="color: #fff;" class="text-center">{{ it.especiedoTitulo}}</td -->
              <!-- td style="color: #fff;" class="text-center">{{ it.dataVencimento}}</td -->
            </tr>
          </tbody>
        </table>
        </div>
        <br><br>
      </div>
    </div>
    </b-modal>
    <div class="text-center">
      <b-modal ref="modalErro"  hide-footer title="Resultado" @ok="confirmar">Não existem editais publicados para o documento pesquisado!<br><b-button @click="hideModal();limparInput()" block  type="button" class="mt-5" variant="primary">Realizar nova pesquisa <font-awesome-icon icon="search"/> </b-button>
    </b-modal>
    </div>
    <div id="wrapper-spinner" v-if="exibir">
      <BeatLoader color="var(--main-azul)" />
    </div>
  </div>
</template>

<script>
import BeatLoader from "vue-spinner/src/BeatLoader.vue";

export default {
  props:['itemsp'],
  components: {
    BeatLoader,
  },
  data() {
    return {
      sitekey: process.env.VUE_APP_sitekeyRecaptcha,
      cpf_cnpj: "",
      logged: false,
      documento: "",
      items: [],
      tok: "",
      exibir: false
    };
  },
  mounted() {
    this.items = this.$props.itemsp;
  },
  filters: {
    moeda: function (value) {
      var v = value.replace(/\D/g,'')
      v = (v/100).toFixed(2) + ''
      v = v.replace(".", ",")
      v = v.replace(/(\d)(\d{3})(\d{3}),/g, "$1.$2.$3,")
      v = v.replace(/(\d)(\d{3}),/g, "$1.$2,")
      return v
    },
    uppertitulo: function (value){
      if (!value) return ''
      value = value.toString()
      var vall = value.toLowerCase()
      return vall.charAt(0).toUpperCase() + vall.slice(1)
    },
    uppert: function (value){
      if (!value) return ''
      value = value.toString()
      return value.toUpperCase()
    },
    dataBr: function (value) {
      if(value.includes('/')) {
        return value;
      }
      var str = value;
      var strSplit = str.split("-");
      var ano = strSplit[0];
      var mes = strSplit[1];
      var dia = strSplit[2].substring(0,2);
      return dia +"/"+ mes +"/"+ ano ;
    },
    SomadataBr: function (value) {
      if(value.includes('/')) {
        return value;
      }
      var str = value;
      var strSplit = str.split("-");
      var ano = strSplit[0];
      var mes = strSplit[1];
      var dia = strSplit[2].substring(0,2);
      var data  = new Date(ano, mes, dia);
      data.setDate(data.getDate() + 3);
      var diaf=data.getDate();
      var mesf=data.getMonth();
      var anof=data.getFullYear();
      var minhaData = diaf + '/' + mesf + '/' + anof;

      return minhaData;
    },
    fone: function (value){
      if (value != undefined) {
        var d = ''
        if(value.length > 10){
          d = value
          d = d.replace(/\D/g, "")
          d = d.replace(/^(\d\d)(\d)/g, "($1) $2")
          d = d.replace(/(\d{5})(\d)/, "$1-$2")
          return d
        }else{
          d = value
          d = d.replace(/\D/g, "")
          d = d.replace(/^(\d\d)(\d)/g, "($1) $2")
          d = d.replace(/(\d{4})(\d)/, "$1-$2")
          return d
        }
      }
    },
    documento: function (value) {
      if (value == null) {
          return '';
      } else {
          let v = value;
          //Remove tudo o que não é dígito
          v = v.replace(/\D/g, "");
          if (v.length < 14) { //CPF
              v = v.replace(/(\d{3})(\d)/, "$1.$2");
              v = v.replace(/(\d{3})(\d)/, "$1.$2");
              v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
          } else { //CNPJ
              v = v.replace(/^(\d{2})(\d)/, "$1.$2");
              v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
              v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
              v = v.replace(/(\d{4})(\d)/, "$1-$2");
          }
          return v;
      }
    }
  },
  methods: {
    //desableRC: function(e) {
    confirmar(){
      document.getElementById("cpf_cnpj").focus()
    },
    solicitar(nm_chave, cpfCnpj) {
      if(nm_chave) {
        if(this.validar()){
          //  iniciando solicitação -> login / cadastro
          //  armazena a chave
          localStorage.setItem("nm_chave", nm_chave)
          localStorage.setItem("cpfCnpj", cpfCnpj)
          //  redireciona para login
          this.$router.push({ name: 'login', params: { tipo_login: 'solicitarCancelamentoAnuencia' } })
        } else {
          alert('informe o cpf')
        }
      }
    },
    validar() {
      let len = this.cpf_cnpj.length;
      //let doc = this.cpf_cnpj
      return len == 11 || len == 14 ? true : false;
      //return len == 11 ? Serv.validarCPF(doc) : len == 14 ? Serv.validarCNPJ(doc) : false
    },
    verificaInputConsulta() {
      if (!this.cpf_cnpj) this.placeholderInputConsulta(true);
    },
    inputConsultaFocus() {
      document.getElementById("cpf_cnpj").focus();
    }
  }
};
</script>

<style scoped>

</style>
